/**
 * Calculate duration in seconds between two ISO date strings.
 * Matches the time_entries.duration column which stores values in SECONDS.
 */
export function calculateDurationSeconds(startIso: string, endIso: string): number {
  return Math.floor((new Date(endIso).getTime() - new Date(startIso).getTime()) / 1000);
}

/**
 * Validate that end time is strictly after start time on the same date.
 * Returns a German error message, or null if valid.
 */
export function validateTimeRange(date: string, startTime: string, endTime: string): string | null {
  const start = new Date(`${date}T${startTime}`);
  const end = new Date(`${date}T${endTime}`);
  if (end <= start) return "Endzeit muss nach Startzeit liegen";
  return null;
}

/**
 * Format elapsed time from a start ISO string to "M:SS" display format.
 * Intended for the live timer display in TimeTracker.
 */
export function formatElapsed(startIso: string): string {
  const diff = Math.max(0, Math.floor((Date.now() - new Date(startIso).getTime()) / 1000));
  const minutes = Math.floor(diff / 60);
  const seconds = diff % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
